import './Whatsapp.css';
import WhatsIcon from "../../images/whatsicon.png";

const WhatsappLogo = () => {
  
    return (
    <div>
      <a
  href="https://wa.me/351932438241"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-button"
>
        <img src={WhatsIcon} className="whatsapp-button-img" alt="Logo Whatsapp" />
      </a>
    </div>
  );
};

export default WhatsappLogo;